<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-base">
      <h2 class="artisan-center">水费充值</h2>
      <van-cell-group title="水费">
        <van-cell title="缴费单位" :value="waterInfo.orgName" />
        <van-cell title="缴费户号" :value="waterInfo.consNo" />
        <van-cell title="缴费户名" :value="waterInfo.consName" />
        <van-cell title="住址信息" :value="waterInfo.addr" />
      </van-cell-group>
      <van-cell-group title="欠缴水费">
        <van-cell title="欠缴金额" @click="rechargeAmount=waterInfo.amount" :value="waterInfo.amount" />
      </van-cell-group>
      <!-- <van-cell-group v-else title="水费余额">
        <van-cell title="剩余金额" :value="waterInfo.amount" />
      </van-cell-group>-->
      <van-cell-group title="水费充值">
        <van-field v-model="rechargeAmount" type="number" label="充值金额" placeholder="充值金额" style="font-weight:bold;" />
        <van-row
          style="text-align:center;padding:7px 16px;height:37px;line-height:37px;"
          gutter="10"
        >
          <van-col
            style="height:32px;line-height:32px;"
            span="6"
            :key="index"
            v-for="(item,index) in suggests"
            @click="selMoney(item)"
          >
            <div
              :class="{'recharge-select':item.isSelect,'recharge-money':!item.isSelect,}"
              v-text="item.amount"
            ></div>
          </van-col>
        </van-row>
      </van-cell-group>
      <div style="margin-top: 16px;">
        <van-button
          :disabled="rechargeAmount<=0"
          color="#46BB36"
          icon="wechat"
          class="artisan-btn"
          round
          block
          type="info"
          @click="recharge"
        >确认充值</van-button>
      </div>
    </div>
  </base-container>
</template>
<script>
import { queryArrears } from "@/api/waterfee";
import { CreateOrder } from "@/api/order";
import { Dialog, Toast } from "vant";
import moment from "moment";
export default {
  data() {
    return {
      isLoading: false,
      rechargeAmount: 0,
      waterInfo: {
        amount: 0,
      },
      suggests: [
        {
          amount: 100,
          isSelect: false,
        },
        {
          amount: 200,
          isSelect: false,
        },
        {
          amount: 300,
          isSelect: false,
        },
        {
          amount: 500,
          isSelect: false,
        },
      ],
    };
  },
  created() {
    this.isLoading = true;
    queryArrears(this.$route.query.waterNo, this.$route.query.groupName)
      .then((res) => {
        this.isLoading = false;
        if (res.data.value) {
          this.waterInfo = res.data.value;
        } else {
          Toast.fail({
            message: res.data.msg,
            duration: 3000,
          });
        }
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  methods: {
    selMoney(item) {
      this.suggests.forEach((c) => (c.isSelect = false));
      item.isSelect = true;
      this.rechargeAmount = item.amount;
    },
    recharge() {
      if (this.rechargeAmount < this.waterInfo.amount) {
        Toast.fail("充值金额不小于欠缴金额");
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "确认立即缴费？",
      }).then(() => {
        this.isLoading = true;
        let merBillNo = moment(new Date()).format("YYYYMMDDHHmmsss");
        //创建订单
        var data = {
          merBillNo,
          payType: "WechatPay",
          busType: "WaterRecharge",
          amount: this.rechargeAmount,
          // amount: 0.01,
          remark: `水费充值-${this.waterInfo.consName}-${this.waterInfo.consNo}-${this.waterInfo.orgName}`,
          waterFeeRechargeInfo: {
            waterNo: this.waterInfo.consNo,
            waterName: this.waterInfo.consName,
            waterAddress: this.waterInfo.addr,
            orgNo: this.waterInfo.orgNo,
            orgName: this.waterInfo.orgName,
            tradeAmount: this.waterInfo.totalOweAmt,
          },
        };
        CreateOrder(data)
          .then((res) => {
            this.isLoading = false;
            const tmp = res.data.value;
            this.toPage("/startpay", {
              billNo: tmp.billNo,
              busType: tmp.busType,
              payType: tmp.payType,
              amount: tmp.amount,
            });
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    toPage(path, query) {
      this.$router.push({ path, query });
    },
  },
};
</script>

<style>
.recharge-money {
  font-weight: bold;
  background: #ebedf0;
}
.recharge-select {
  font-weight: bold;
  background: #46bb36;
  color: #fff;
}
</style>